<template>
  <v-row>
    <v-col
      v-for="(substep, index) in substeps"
      :key="index"
      :class="[
        substep.class,
        index === 0 ? 'border-radius-top border-radius-left' : '',
        index === substeps.length - 1 ? 'border-radius-bottom border-radius-right' : '',
      ]"
      class="substep-card-bg borders"
      cols="12"
      :lg="substep.lg"
    >
      <Substep :substep="substep" />
    </v-col>
    <BlurredBackdropUpselling
      class="upselling-dialog"
      v-if="showBlurredBackdropUpselling"
    />
  </v-row>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

import BlurredBackdropUpselling from '@/components/BlurredBackdropUpselling.vue'
import { Substep as SubstepInterface } from '@/modules/landingpage/models/Substep'

import Substep from './Substep.vue'

defineProps({
  showBlurredBackdropUpselling: {
    type: Boolean,
    default: false,
  },
  substeps: {
    type: Array as PropType<SubstepInterface[]>,
    required: true,
  },
})
</script>

<style scoped>
.upselling-dialog {
  position: static;
  margin-top: -30%;
}

.substep-card-bg {
  background: #eef4f4;
}

.borders {
  border-radius: 0;
}

.border-radius-left {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.border-radius-right {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
@media (max-width: 1280px) {
  .borders {
    border-radius: 0;
  }
  .border-radius-top {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .border-radius-bottom {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}
</style>
